export enum JobLevel {
  APPRENTICE = 'apprentice',
  YOUNG_PROFESSIONAL = 'young professional',
  PROFESSIONAL = 'professional',
  MANAGEMENT = 'management',
}

export enum JobGroup {
  MANAGEMENT = 'Management-Team',
  DESIGNER = 'Designer',
  DEVELOPER = 'Developer',
  SOCIAL_MEDIA = 'Social-Media',
}

export enum JobTitle {
  HEAD_OF_APPS = 'Head of Apps Team',
  MEDIAMATIKER = 'Mediamatiker',
  MEDIAMATIKERIN = 'Mediamatikerin',
  FRONTEND = 'Frontend Developer',
  BACKEND = 'Backend Developer',
  FULLSTACK = 'Fullstack Developer',
  AI_DEV = 'AI Developer',
  IMD = 'IMD',
  DESIGN = 'Design',
  EDB = 'EDB',
  KV = 'KV',
}

export type TeamRole = {
  level: JobLevel;
  jobTitle: JobTitle;
  jobGroup: JobGroup;
};

export const JobTitlesByGroup: Record<JobGroup, JobTitle[]> = {
  [JobGroup.MANAGEMENT]: [JobTitle.HEAD_OF_APPS, JobTitle.EDB],
  [JobGroup.DESIGNER]: [
    JobTitle.DESIGN,
    JobTitle.IMD,
    JobTitle.MEDIAMATIKER,
    JobTitle.MEDIAMATIKERIN,
  ],
  [JobGroup.DEVELOPER]: [
    JobTitle.FRONTEND,
    JobTitle.BACKEND,
    JobTitle.FULLSTACK,
    JobTitle.AI_DEV,
  ],
  [JobGroup.SOCIAL_MEDIA]: [
    JobTitle.MEDIAMATIKER,
    JobTitle.MEDIAMATIKERIN,
    JobTitle.KV,
  ],
};
